<template>
  <div class="omni-theme-box" :style="boxStyle" @click="onClick"></div>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      required: true
    },
    foregroundColor: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    boxStyle() {
      return {
        background: `linear-gradient(45deg, ${this.backgroundColor} 50%, ${this.foregroundColor} 50%)`,
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        border: this.active ? '2px solid #0c0' : '2px solid #ccc',
        transform: this.active ? 'rotate(45deg)' : 'none',
        transition: 'transform 0.3s ease-in'
      };
    }
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>

<style>
.omni-theme-box {
  cursor: pointer;
}
</style>